<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>级别价格设置</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="formBody">
        <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" prop="id" label="序列号" width="120">
        </el-table-column>
        <el-table-column align="center" prop="level" label="等级" width="150">
        </el-table-column>
        <el-table-column align="center" prop="amount" label="价格" min-width="50">
          <template slot-scope="scope">
              <div v-html="scope.row.amount"></div>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="50" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editUser(scope.$index, scope.row)">修改价格</el-button>
          </template>
        </el-table-column>
      </el-table>
  
        <el-dialog title="修改级别价格" :visible.sync="editTwoFormVisible" width="30%" @click='closeDialog()'>
          <el-form label-width="80px">
            <el-form-item label="价格" prop="userName">
              <el-input size="small" v-model="newShowData.amount" auto-complete="off" placeholder="请输入价格"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog()'>取消</el-button>
            <el-button size="small" type="primary" :loading="loading" class="title" @click="submitFormUnit()">保存</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        userData: [],
        editTwoFormVisible: false,
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        newShowData:[]
      }
    },
    // 注册组件
    components: {
      
    },
    created() {
      
    },
    methods: {
      //显示编辑界面
      editUser: function(index, row) {
        console.log(row)
        this.newShowData = row;
        this.editTwoFormVisible = true;
      },
      closeDialog() {
        this.editTwoFormVisible = false
      },
    }
  }
  </script>
  
  <style scoped>
  .formBody{
    margin-top: 40px;
  }
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  </style>
  
   
   


// WEBPACK FOOTER //
// src/views/adminSet/levelSet.vue